import instamapsBreadcrumbs from '../shared/components/breadcrumbs/breadcrumbs.vue';
import instamapsPerfilFeatured from './components/perfil-featured/perfil-featured.vue';
import instamapsPerfilList from './components/perfil-list/perfil-list.vue';
import instamapsBorrarModal from './components/borrar-modal/borrar-modal.vue';
import instamapsBorrarAppModal from './components/borrar-app-modal/borrar-app-modal.vue';
import instamapsDuplicarModal from './components/duplicar-modal/duplicar-modal.vue';
import instamapsCompartirModal from './components/compartir-modal/compartir-modal.vue';
import instamapsColaboraModal from './components/colabora-modal/colabora-modal.vue';
import instamapsCambiarPasswordModal from './components/cambiar-password-modal/cambiar-password-modal.vue';
import instamapsMessageModal from '../shared/components/message-modal/message-modal.vue';
import instamapsBajaModal from './components/baja-modal/baja-modal.vue';
import instamapsVisibilitatModal from './components/visibilitat-modal/visibilitat-modal.vue';
import instamapsCrearUsuarisModal from './components/crearusuaris-modal/crearusuaris-modal.vue';
import messages from './perfil-translations';
import { SharedService } from '../shared/services/sharedService';
import { PerfilService } from './services/perfilService';

export default {
    name: 'instamapsPerfil',
    i18n: {
        messages,
    },
    data: function () {
        return {
            availableMaps: 0,
            lastActivity: new Date(),
            modalIsError: false,
            modalIsLoaded: false,
            modalBorrarIsLoaded: false,
            modalBorrarColaboradorIsLoaded: false,
            modalBorrarAppIsLoaded: false,
            modalBajaIsLoaded: false,
            modalCambiarPasswordIsLoaded: false,
            modalDuplicarIsLoaded: false,
            modalCompartirIsLoaded: false,
            modalColaboraIsLoaded: false,
            modalVisibilitatIsLoaded: false,
            modalCrearUsuarisIsLoaded: false,
            currentMapa: {},
            mapaBorrar: "",
            appBorrar: "",
            mapaVisibilitat: "",
            modalTitle: "",
            modalMessage: "",
            refreshMaps: false,
            user: {},
        };
    },
    props: {
        selectedLang: { type: String },
        hasBreadcrumbs: { type: Boolean },
    },
    components: {
        instamapsBreadcrumbs,
        instamapsPerfilFeatured,
        instamapsPerfilList,
        instamapsBorrarModal,
        instamapsBorrarAppModal,
        instamapsCambiarPasswordModal,
        instamapsMessageModal,
        instamapsDuplicarModal,
        instamapsCompartirModal,
        instamapsColaboraModal,
        instamapsBajaModal,
        instamapsVisibilitatModal,
        instamapsCrearUsuarisModal,
    },
    filters: {
        dateFormat: (value) => SharedService.dateFormat(value),
    },
    computed: {
        _availableMaps: function () {
            return this.availableMaps;
        },
        _lastActivity: function () {
            return this.lastActivity;
        },
    },
    methods: {
        updateStats: function (ev) {
            this.availableMaps = ev.availableMaps;
            this.lastActivity = ev.lastActivity;
        },
        loading: function () {
            this.$emit('loading');
        },
        loaded: function (ev) {
            this.updateStats(ev);
            this.refreshMaps = false;
            this.$emit('loaded');
        },
        loadedCambiarPassword: function(){
            this.modalIsError = false;
            this.modalCambiarPasswordIsLoaded = false;
        },
        showModalPassword: function(){
            this.modalIsError = false;
            this.modalCambiarPasswordIsLoaded = true;
        },
        loadedBorrar: function(){
            this.modalIsError = false;
            this.modalBorrarIsLoaded = false;
            this.modalBorrarColaboradorIsLoaded=false;
        },
        loadedBorrarApp: function(){
            this.modalIsError = false;
            this.modalBorrarAppIsLoaded = false;
        },
        showModalBorrar: function(ev){
            this.currentMapa = ev.mapa;
            this.modalIsError = true;
            this.modalBorrarIsLoaded = true;
        },
        showModalBorrarColaborador: function(ev){
            this.currentMapa = ev.mapa;
            this.modalIsError = true;
            this.modalBorrarColaboradorIsLoaded = true;
        },
        showModalBorrarApp: function(ev){
            this.currentMapa = ev.mapa;
            this.modalIsError = true;
            this.modalBorrarAppIsLoaded = true;
        },
        loadedMessage: function(){
            this.modalIsError = false;
            this.modalIsLoaded = false;
        },
        showModalOk: function(ev){
            this.modalTitle = ev.title;
            this.modalMessage = ev.message;
            this.modalIsError = false;
            this.modalIsLoaded = true;
        },
        showModalError: function(ev){
            this.modalTitle = ev.title;
            this.modalMessage = ev.message;
            this.modalIsError = true;
            this.modalIsLoaded = true;
        },
        showModalDuplicar: function(ev){
            this.currentMapa = ev.mapa;
            this.modalIsError = false;
            this.modalDuplicarIsLoaded = true;
        },
        loadedDuplicar: function(){
            this.modalIsError = false;
            this.modalDuplicarIsLoaded = false;
        },
        duplicarMapa: function(){
            this.refreshMaps = true;
        },
        derivatsMapa: function(){
            this.refreshMaps = true;
        }, 
        esborrarMapa: function(ev){
            this.mapaBorrar = ev.businessId;
        },
        esborrarApp: function(ev){
            this.appBorrar = ev.businessId;
        },
        showModalCompartir: function(ev){
            this.currentMapa = ev.mapa;
            this.modalIsError = false;
            this.modalCompartirIsLoaded = true;
        },
        loadedCompartir: function(){
            this.modalIsError = false;
            this.modalCompartirIsLoaded = false;
        },
        showModalColabora: function(ev){
            this.currentMapa = ev.mapa;
            this.modalIsError = false;
            this.modalColaboraIsLoaded = true;
        },
        loadedColabora: function(){
            this.modalIsError = false;
            this.modalColaboraIsLoaded = false;
        },
        loadedBaja: function(){
            this.modalIsError = false;
            this.modalBajaIsLoaded = false;
        },
        showModalBaja: function(){
            this.modalIsError = true;
            this.modalBajaIsLoaded = true;
        },
        showModalVisibilitat: function(ev){
            this.currentMapa = ev.mapa;
            this.modalIsError = false;
            this.modalVisibilitatIsLoaded = true;  
        },
        loadedVisibilitat: function(){
            this.modalIsError = false;
            this.modalVisibilitatIsLoaded = false;
        },
        loadedCrearUsuaris: function(){
            this.modalIsError = false;
            this.modalCrearUsuarisIsLoaded = false;
        },
        showModalCrearUsuari: function(ev){
            this.currentMapa = ev.mapa;
            this.modalIsError = true;
            this.modalCrearUsuarisIsLoaded = true;
        },
        bajaUsuario: function(){
            this.$emit('logout');
        },
        changeVisibility: function(ev){
            this.mapaVisibilitat = ev.businessId+"_"+ev.visibilitat;
        },
        userLogout: function(){
            this.$emit('logout');
        },
    },
    mounted(){
        PerfilService.getUser().then((user) => {
            let results = user.body.results;
            this.user = results;
        });
    }
};



// WEBPACK FOOTER //
// ./src/perfil/perfil.js